"use strict";
// _partialFile.js

{
  // シンプルなカウントアップアニメーション関数
  function animateCounter(element, targetValue, duration = 2000) {
    const startValue = 0; // 0からスタート
    const startTime = performance.now(); // アニメーション開始時刻を記録

    // カウンター更新用の内部関数
    function updateCounter(currentTime) {
      // currentTime: requestAnimationFrameが渡す現在時刻
      const elapsed = currentTime - startTime; // 経過時間を計算
      const progress = Math.min(elapsed / duration, 1); // 進捗割合を計算（0〜1）
      const currentValue = startValue + (targetValue - startValue) * progress; // 現在の値を計算

      // 表示更新（目標値の型によって分岐）
      if (targetValue % 1 !== 0) {
        element.textContent = currentValue.toFixed(1); // 小数点を含む場合：小数点1桁で表示
      } else {
        element.textContent = Math.round(currentValue); // 整数の場合：四捨五入して表示
      }

      // アニメーションが完了していない場合
      if (progress < 1) {
        requestAnimationFrame(updateCounter); // 次のフレームで再実行
      }
    }

    requestAnimationFrame(updateCounter); // アニメーション開始
  }

  // ページ読み込み完了時に自動実行
  document.addEventListener("DOMContentLoaded", function () {
    // .js-count-upクラスを持つ要素を全て取得
    const elements = document.querySelectorAll(".js-count-up");

    // 各要素に対してアニメーションを設定
    elements.forEach((element) => {
      const targetValue = parseFloat(element.getAttribute("data-target")) || 100; // data-target属性から目標値を取得
      const duration = parseInt(element.getAttribute("data-duration")) || 2000; // data-duration属性から時間を取得（デフォルト2秒）

      // 目標値が設定されている場合のみアニメーション実行
      if (targetValue) {
        setTimeout(() => {
          // 0.5秒遅延させて開始
          animateCounter(element, targetValue, duration);
        }, 500);
      }
    });
  });
}
